import { createFileRoute } from '@tanstack/react-router'

import { DefaultLoader } from '#components/default-loader.tsx'
import { AutomationDetailPage } from '#features/automations/automation-detail-page.tsx'

export const Route = createFileRoute(
  '/_app/$workspace/_dashboard/automations/$id/',
)({
  head: () => ({ meta: [{ title: 'Automation' }] }),
  component: RouteComponent,
  pendingComponent: DefaultLoader,
})

function RouteComponent() {
  const params = Route.useParams()
  return <AutomationDetailPage key={params.id} automationId={params.id} />
}
